"use client";

import { Route } from "@faire/web-api/Route";
import { props as productPageRouteProps } from "@faire/web-api/routes/product/productToken";
import React, { ComponentProps } from "react";

import { LazyProductPage, ProductPageProvider } from "@faire/retailer/views/product";
import { Product } from "@faire/retailer/views/product/Product";

export const EagerlyRenderProductPageRoute = () => {
  return <Route {...productPageRouteProps} component={EagerProductPage} />;
};

const EagerProductPage = (props: ComponentProps<typeof LazyProductPage>) => {
  return (
    <ProductPageProvider value={Product}>
      <LazyProductPage {...props} />
    </ProductPageProvider>
  );
};
